import React from 'react';
import './StatsCard.scss';

/**
 * StatsCard Component - Displays key metrics with optional icon
 * Matches UX_DESIGNS styling with theme support
 */
// Each variant has 3 wave layers: fill (bottom), line1 (mid), line2 (top)
const WAVE_DATA = {
  emerald: {
    fill: 'M0,55 C50,40 100,60 150,45 C200,30 250,50 300,38 L300,100 L0,100 Z',
    line1: 'M0,48 C50,35 100,52 150,38 C200,24 250,44 300,32',
    line2: 'M0,40 C55,28 105,48 160,33 C210,18 260,38 300,26',
    colors: { fill: 'rgba(16,185,129,0.08)', line1: 'rgba(16,185,129,0.15)', line2: 'rgba(16,185,129,0.08)' },
  },
  amber: {
    fill: 'M0,58 C45,42 95,62 145,48 C195,32 245,52 300,40 L300,100 L0,100 Z',
    line1: 'M0,50 C45,36 100,55 150,42 C200,28 250,48 300,35',
    line2: 'M0,42 C50,30 100,48 155,35 C205,22 255,40 300,28',
    colors: { fill: 'rgba(245,158,11,0.07)', line1: 'rgba(245,158,11,0.14)', line2: 'rgba(245,158,11,0.07)' },
  },
  blue: {
    fill: 'M0,52 C55,38 105,58 155,44 C205,28 255,50 300,36 L300,100 L0,100 Z',
    line1: 'M0,45 C55,32 110,50 160,37 C210,24 260,42 300,30',
    line2: 'M0,38 C60,26 110,44 165,30 C215,18 265,36 300,24',
    colors: { fill: 'rgba(59,130,246,0.07)', line1: 'rgba(59,130,246,0.14)', line2: 'rgba(59,130,246,0.07)' },
  },
  violet: {
    fill: 'M0,56 C50,40 100,60 150,46 C200,30 250,52 300,38 L300,100 L0,100 Z',
    line1: 'M0,48 C50,34 105,54 155,40 C205,26 255,46 300,32',
    line2: 'M0,40 C55,28 108,46 160,34 C210,20 260,38 300,26',
    colors: { fill: 'rgba(139,92,246,0.07)', line1: 'rgba(139,92,246,0.14)', line2: 'rgba(139,92,246,0.07)' },
  },
  rose: {
    fill: 'M0,54 C48,40 98,60 148,45 C198,30 248,50 300,38 L300,100 L0,100 Z',
    line1: 'M0,46 C48,34 100,52 152,38 C202,24 252,44 300,32',
    line2: 'M0,38 C52,27 104,46 158,32 C208,18 258,38 300,26',
    colors: { fill: 'rgba(244,63,94,0.07)', line1: 'rgba(244,63,94,0.14)', line2: 'rgba(244,63,94,0.07)' },
  },
  cyan: {
    fill: 'M0,56 C52,42 102,60 152,46 C202,32 252,50 300,38 L300,100 L0,100 Z',
    line1: 'M0,48 C52,36 104,52 156,40 C206,26 256,46 300,34',
    line2: 'M0,40 C56,28 106,46 160,34 C212,20 260,40 300,28',
    colors: { fill: 'rgba(6,182,212,0.07)', line1: 'rgba(6,182,212,0.14)', line2: 'rgba(6,182,212,0.07)' },
  },
};

const StatsCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = 'blue',
  gradient = '',
  className = ''
}) => {
  const waveData = WAVE_DATA[gradient];

  return (
    <div className={`stats-card hover-elevate ${gradient ? `stats-card--gradient-${gradient}` : ''} ${className}`}>
      {waveData && (
        <svg className="stats-card__wave" viewBox="0 0 300 100" preserveAspectRatio="none">
          <path d={waveData.fill} fill={waveData.colors.fill} />
          <path d={waveData.line1} fill="none" stroke={waveData.colors.line1} strokeWidth="1.5" />
          <path d={waveData.line2} fill="none" stroke={waveData.colors.line2} strokeWidth="1" />
        </svg>
      )}
      <div className="stats-card__content">
        <div className="stats-card__text">
          <p className="stats-card__title">{title}</p>
          <p className="stats-card__value">{value}</p>
          {subtitle && (
            <p className="stats-card__subtitle">{subtitle}</p>
          )}
        </div>
        {Icon && (
          <div className={`stats-card__icon stats-card__icon--${iconColor}`}>
            <Icon size={20} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
